import { getSessionToken } from '@/utils/http';
import queryKeys from '@/constants/queryKeys';
import jwtDecode from 'jwt-decode';
import { useQuery, UseQueryOptions } from 'react-query';

interface SessionTokenData {
  dat: {
    is_view_only: boolean;
    user_id: number;
    account_id: number;
  };
}

type Options = UseQueryOptions<{ data: string }, Error, SessionTokenData>;

export const useGetSessionToken = (options?: Options) => {
  return useQuery<{ data: string }, Error, SessionTokenData>(
    queryKeys.MONDAY_GET_SESSION_TOKEN,
    async () => {
      const res = await getSessionToken();
      if (!res?.data) throw new Error('Failed to get session token');
      return res;
    },
    {
      cacheTime: Infinity,
      select: (res: { data: string }) => jwtDecode<SessionTokenData>(res.data),
      ...options,
    },
  );
};
